import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { HeroQuotes } from './components/HeroQuotes';
import { Problems } from './components/Problems';
import { SystemOverview } from './components/SystemOverview';
import { Roadmap } from './components/Roadmap';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { BeforeAfter } from './components/BeforeAfter';
import { FinalCountdown } from './components/FinalCountdown';
import { FinalThoughts } from './components/FinalThoughts';
import { ChihuahuaNote } from './components/ChihuahuaNote';
import { SiteFooter } from './components/SiteFooter';
import { StickyMobileCta } from './components/StickyMobileCta';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="3ikqyfyb7r257">
      <noscript data-id="element-1" data-mp="3ii4s22026sok">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3mlavl1vse5rc" />
      </noscript>
      <Hero data-id="element-3" data-mp="680frswe88f" />
      <main data-id="element-4" data-mp="4n53zyrel9i">
        <HeroQuotes data-id="element-5" data-mp="5ggxfcks0yi" />
        <Problems data-id="element-6" data-mp="7su7f7e1n58" />
        <SystemOverview data-id="element-7" data-mp="2zld0z6e9z99y" />
        <Roadmap data-id="element-8" data-mp="2zlv3gkrj6jqb" />
        <Bonuses data-id="element-9" data-mp="2zmemk4sx3e5x" />
        <Offer data-id="element-10" data-mp="2zmwlj96ys6hj" />
        <Testimonials data-id="element-11" data-mp="2zng2amkvootz" />
        <Guarantee data-id="element-12" data-mp="33m5b01uz1i7a" />
        <Faq data-id="element-13" data-mp="33nq6put0v76q" />
        <BeforeAfter data-id="element-14" data-mp="33ngiabnml835" />
        <FinalCountdown data-id="element-15" data-mp="33orik1hv3xpi" />
        <FinalThoughts data-id="element-16" data-mp="38m1g64fenfof" />
        <ChihuahuaNote data-id="element-17" data-mp="38li77d7qg1mj" />
      </main>
      <SiteFooter data-id="element-18" data-mp="38kgmsi4tu2s5" />
      <div className="h-20 sm:hidden" aria-hidden="true" data-id="element-19" data-mp="38o4edbqpof48" />
      <StickyMobileCta data-id="element-20" data-mp="3dlns8ajhypvn" />
    </div>;
}